"use client";

/**
 * SoftBlockHint renders the short inline message shown under a disabled CTA
 * when a feature flag (or maintenance) soft-blocks an entrance.
 */
export function SoftBlockHint({
  message,
  className = "mt-2 text-sm text-amber-300/90 text-center",
}: {
  message: string | null | undefined;
  className?: string;
}) {
  if (!message) {
    return null;
  }
  return (
    <p className={className} role="status">
      {message}
    </p>
  );
}
